import styled from "styled-components";

export const PremiumPubReviewItemWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  background: var(--Black-100, #f0f0f0);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PremiumPubReviewUserInfoWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  > img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
`;

export const PremiumPubReviewUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;

  > .count {
    width: 66px;
  }
`;

export const PremiumPubReviewUserInfoTop = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  > .edit {
    font-size: 12px;
    color: gray;
  }
`;

export const PremiumPubReviewUserInfoUser = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  > .name {
    font-weight: 600;
    font-size: 14px;
    color: var(--Black-400, #444444);
  }

  > .time {
    font-weight: 400;
    font-size: 10px;
    color: var(--Black-300, #808080);
  }
`;

export const PremiumPubReviewItemContentWrapper = styled.div`
  font-weight: 400;
  font-size: 13px;
`;

export const PremiumPubReviewItemImageWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const PremiumPubReviewItemImage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;

  > img {
    width: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
    border: 1px solid var(--Black-100, #f0f0f0);
  }

  > .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    fontsize: 14px;
  }
`;
